import React from 'react'

// components
import { Typography, Button } from '@mui/material'
import dateFnsFormat from 'date-fns/format'

import { hasPermission } from '../../context/user/UserContext'
import { Permissions } from '../../entities/permissions'

export default function generate({ t, classes, tableData, user, onModify }) {
  return [
    {
      name: 'user',
      label: t('common.firstName'),
      options: {
        sort: false,
        customBodyRender: (val, tableMeta) => {
          const activeClassName = tableData.items[tableMeta.rowIndex].user
            .isActive
            ? ''
            : classes.disabled
          return (
            <Typography variant="body2" className={activeClassName}>
              {tableData.items[tableMeta.rowIndex].user.firstName}
            </Typography>
          )
        },
      },
    },
    {
      name: 'user',
      label: t('common.lastName'),
      options: {
        sort: false,
        customBodyRender: (val, tableMeta) => {
          const activeClassName = tableData.items[tableMeta.rowIndex].user
            .isActive
            ? ''
            : classes.disabled
          return (
            <Typography variant="body2" className={activeClassName}>
              {tableData.items[tableMeta.rowIndex].user.lastName}
            </Typography>
          )
        },
      },
    },
    {
      name: 'user',
      label: t('common.email'),
      options: {
        sort: false,
        customBodyRender: (val, tableMeta) => {
          const activeClassName = tableData.items[tableMeta.rowIndex].user
            .isActive
            ? ''
            : classes.disabled
          return (
            <Typography variant="body2" className={activeClassName}>
              {tableData.items[tableMeta.rowIndex].user.email}
            </Typography>
          )
        },
      },
    },
    {
      name: 'userType',
      label: t('subscriptions.user-type'),
      options: {
        sort: true,
        customBodyRender: (val, tableMeta) => {
          const activeClassName = tableData.items[tableMeta.rowIndex].user
            .isActive
            ? ''
            : classes.disabled
          return (
            <Typography variant="body2" className={activeClassName}>
              {tableData.items[tableMeta.rowIndex].user.roleName}
            </Typography>
          )
        },
      },
    },
    {
      name: 'status',
      label: t('subscriptions.status'),
      options: {
        sort: true,
        customBodyRender: (val, tableMeta) => {
          const activeClassName = tableData.items[tableMeta.rowIndex].user
            .isActive
            ? ''
            : classes.disabled
          if (tableData.items[tableMeta.rowIndex].status === 'paid') {
            return (
              <Typography variant="body2" className={classes.greenText}>
                {tableData.items[tableMeta.rowIndex].statusLabel}
              </Typography>
            )
          }
          if (tableData.items[tableMeta.rowIndex].status === 'not_paid') {
            return (
              <Typography variant="body2" className={classes.redText}>
                {tableData.items[tableMeta.rowIndex].statusLabel}
              </Typography>
            )
          }
          // Default case if statusLabel is neither paid nor not-paid (not_subscribed)
          return (
            <Typography variant="body2" className={activeClassName}>
              {tableData.items[tableMeta.rowIndex].statusLabel}
            </Typography>
          )
        },
      },
    },
    {
      name: 'validUntil',
      label: t('subscriptions.valid-until'),
      options: {
        sort: true,
        customBodyRender: (val, tableMeta) => {
          const activeClassName = tableData.items[tableMeta.rowIndex].user
            .isActive
            ? ''
            : classes.disabled
          const validUntil = tableData.items[tableMeta.rowIndex].validUntil
          if (!validUntil) {
            return (
              <Typography variant="body2" className={activeClassName}>
                {''}
              </Typography>
            )
          }
          return (
            <Typography variant="body2" className={activeClassName}>
              {dateFnsFormat(
                Date.parse(tableData.items[tableMeta.rowIndex].validUntil),
                'dd/MM/yyyy'
              )}
            </Typography>
          )
        },
      },
    },
    {
      name: 'modify',
      label: ' ',
      options: {
        sort: false,
        customBodyRender: (val, tableMeta) => {
          if (hasPermission(Permissions.PAGE_USERS_MANAGE_PASSWORDS, user)) {
            return (
              <Button
                className={classes.linkButton}
                variant="text"
                onClick={() => onModify(tableData.items[tableMeta.rowIndex])}
                color="primary"
                disabled={!tableData.items[tableMeta.rowIndex].user.isActive}
              >
                {t('common.modify')}
              </Button>
            )
          }
          return ''
        },
      },
    },
  ]
}
